export const convertToLocalDateTime = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleString(); // Converts to local date-time
};
